import React, { Component } from 'react'
export default class Modal extends Component {

    constructor(props) {
        super(props);
    }

    componentDidUpdate(prevProps) {
        // validate if the props changes
        if (prevProps.show != this.props.show) {
            $(this.refs.modal).modal(this.props.show ? 'show' : 'hide');
        }
    }

    initTableDetalle(data) {

        const $table = $(this.refs.tblFacturasDetalle);
        let _columnas = [];
        let _returns = '';

        _columnas = [{
            title: 'Tipo',
            field: 'Tipo',
            sortable: true
        }, {
            title: 'Folio',
            field: 'Fiscal_NumeroFacturaGlobal'
        }, {
            title: 'Monto',
            field: 'Total',
            sortable: true
            }, {
                title: 'Fecha Generación',
                field: 'Fecha_Generacion',
                sortable: true
            }, {
                title: 'Estado',
                field: 'Estado',
                sortable: true
            }, {
                title: 'Fecha Anulación',
                field: 'Fecha_Anulacion',
                sortable: true
            }];
        $table.bootstrapTable('destroy');

        $table.bootstrapTable({
            data: data || [],
            cache: false,
            height: 200,
            striped: false,
            pagination: false,
            sortable: true,
            locale: 'es-Ar',
            sortOrder: 'asc',
            showToggle: false,
            showPaginationSwitch: false,
            pageSize: 10,
            pageList: [10, 20, 30, 150, 250, 350, 500],
            search: false,
            showColumns: false,
            showRefresh: false,
            minimumCountColumns: 3,
            clickToSelect: false,
            rowAttributes: function (row) {

                if (row.Semana === 0 && row.Mes === 0) {
                    return { 'data-id': row.Operacion_id, 'data-genera': row.Fiscal_NumeroFacturaGlobal === '' }
                }
                else {
                    return { 'data-id': row.Operacion_Inicial, 'data-genera': row.Fiscal_NumeroFacturaGlobal === '' }
                }
            },
            columns: _columnas
        });
    }

    loadTable(data) {
        const $table = $(this.refs.tblFacturasDetalle);
        $table.bootstrapTable('load', data || []);
    }

    render() {
        const { operacion, fecha, data, onCloseModal } = this.props;
        this.initTableDetalle(data);
        return (
            <div className="modal" tabIndex="-1" role="dialog" ref="modal" >
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Detalle CFDI Globales</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onCloseModal}>
                                <span aria-hidden="false">&times;</span>
                            </button>
                        </div> 
                        <div className="modal-body">
                            <p>Operación: {operacion}</p> <p>Fecha: {fecha}</p>
                            <div className="row d-flex justify-content-center">
                                <div className="col-md-12">
                                    <table ref="tblFacturasDetalle"></table>
                                </div>
                            </div> 
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" aria-label="Close" onClick={onCloseModal}>
                                <i className="fas fa-window-close"></i> Cerrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./Public/src/js/util/modal/Detalle.jsx